import * as actionType from "./actionTypes";
import { API_URL, API_HEADERS } from "../../constants/api";
import { apiPost, apiRequest } from "../../utils/api_service";
import { getTimeZone } from "../../utils/helper";
import moment from "moment";

export const getUserData = () => dispatch => {
  // apiRequest({
  //   url: API_URL.user.GetUserOrganizationDetails
  // }).then(({ data: response }) => {
    //console.log("CloudOrg",response);
   localStorage.setItem(API_HEADERS.CID, 2);
    apiRequest({
      url: API_URL.user.GetUserConfigurationDetails
    }).then(({ data: response }) => {
      if(response !=undefined){
      const accessGroupId =
        ((response || {}).groups[0] || []).accessGroupId || 0;
      localStorage.setItem(API_HEADERS.AGI, accessGroupId);

      const isExternalLog =
        localStorage.getItem("isExternalContractor") === "true" &&
        (((response || {}).groups[0] || []).groupName || "") ===
          "DC_Contractor";
      if (localStorage.getItem("loggedInLog") === "true" || isExternalLog) {
        apiPost({
          url: API_URL.user.UpdateUserLoginLog,
          postBody: { timeZone: getTimeZone(), EmailId: response.email, DateTimeOffset: moment().utcOffset() }
        }).then(() => {
          localStorage.removeItem("loggedInLog");
          localStorage.removeItem("isExternalContractor");
        });
      }
    }
      dispatch({
        type: actionType.GET_USER_DATA,
        payload: response
      });
    });
  // });
};

/** Set loading screen */
export const setLoadingScreen = isLoading => dispatch => {
  return dispatch({
    type: actionType.SET_LOADER_SCREEN,
    payload: isLoading
  });
};
